import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.rmAccount.view.headerTitle' }),
    headerDescription: translate({ id: 'settings.rmAccount.view.headerDescription' }),

    name: translate({ id: 'settings.rmAccount.view.name' }),
    surname: translate({ id: 'settings.rmAccount.view.surname' }),
    username: translate({ id: 'settings.rmAccount.view.username' }),
    email: translate({ id: 'settings.rmAccount.view.email' }),
    apiKey: translate({ id: 'settings.rmAccount.view.apiKey' }),

    missingApiKey: translate({ id: 'settings.rmAccount.view.missingApiKey' }),

    edit: translate({ id: 'settings.rmAccount.view.edit' }),
    changePassword: translate({ id: 'settings.rmAccount.view.changePassword' }),

    copy: translate({ id: 'settings.rmAccount.view.copy' }),
    reset: translate({ id: 'settings.rmAccount.view.reset' }),
    apiKeyNotSet: translate({ id: 'settings.rmAccount.edit.fields.apiKey.notSet' }),

    copyApiKeySuccess: translate({ id: 'settings.rmAccount.view.copyApiKeySuccess' }),
    copyApiKeyError: translate({ id: 'settings.rmAccount.view.copyApiKeyError' }),

    requestApiKeySuccess: translate({ id: 'settings.rmAccount.view.requestApiKeySuccess' }),
  }))

  return api
}
